function isStylesheet(node: ChildNode): boolean {
  return (
    node instanceof HTMLStyleElement ||
    (node instanceof HTMLLinkElement && node.relList.contains('stylesheet'))
  );
}

export function removeOldHead(parent: HTMLElement = document.head) {
  let foundOldHeader = false;
  const nodesToRemove: ChildNode[] = [];
  for (const node of parent.childNodes) {
    if (!foundOldHeader && node.nodeName !== '#comment') {
      continue;
    }
    if (
      foundOldHeader &&
      node.nodeName === '#comment' &&
      node.nodeValue === 'end head'
    ) {
      nodesToRemove.push(node);
      break;
    }
    if (
      foundOldHeader ||
      (node.nodeName === '#comment' && node.nodeValue === 'start head')
    ) {
      foundOldHeader = true;
      // Keep stylesheets so Vite's code-split component CSS isn't orphaned on client-side nav
      if (!isStylesheet(node)) {
        nodesToRemove.push(node);
      }
    }
  }
  for (const node of nodesToRemove) {
    node.remove();
  }
}
